// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from "@sentry/nextjs";
import appConfig from "./config";
import { consumeParentCapabilityUrl } from "./lib/parentCapability";
import { sanitizeTelemetry } from "./lib/telemetryPrivacy";

consumeParentCapabilityUrl();

const isCypress =
  typeof window !== "undefined" && !!(window as any).Cypress;

if (appConfig.environment === "production" && !isCypress) {
  Sentry.init({
    dsn: "https://30eae61c2f7bd491bf728e120b7c0569@o4510698474176512.ingest.de.sentry.io/4510702429012048",

    // Disable Sentry in development and test runners
    enabled: appConfig.environment === "production" && !isCypress,

    // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
    tracesSampleRate: 1,
    // Enable logs to be sent to Sentry
    enableLogs: true,

    // Enable sending user PII (Personally Identifiable Information)
    // https://docs.sentry.io/platforms/javascript/guides/nextjs/configuration/options/#sendDefaultPii
    sendDefaultPii: true,

    beforeBreadcrumb: (breadcrumb) => sanitizeTelemetry(breadcrumb),
    beforeSendTransaction: (event) => sanitizeTelemetry(event),
    beforeSendLog: (log) => sanitizeTelemetry(log),
    beforeSend(event) {
      const frames = event.exception?.values?.[0]?.stacktrace?.frames;
      // Drop errors from browser extensions and third-party scripts
      if (
        frames?.length &&
        frames.every((f) => !f.filename || f.filename === "<anonymous>")
      ) {
        return null;
      }
      return sanitizeTelemetry(event);
    }
  });
}

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
